import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a736d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "empl-review__title"
}
const _hoisted_2 = {
  key: 1,
  class: "empl-review__info"
}
const _hoisted_3 = { class: "empl-review__name" }
const _hoisted_4 = { class: "empl-review__desc" }
const _hoisted_5 = {
  key: 2,
  class: "empl-review__middle-content"
}
const _hoisted_6 = { class: "empl-review__subtitle empl-review--center" }
const _hoisted_7 = {
  key: 0,
  class: "empl-review__note empl-review--msg-align"
}
const _hoisted_8 = {
  key: 3,
  class: "empl-review__middle-content"
}
const _hoisted_9 = { class: "empl-review__subtitle empl-review--center" }
const _hoisted_10 = { class: "comment__wrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "empl-review__note" }
const _hoisted_13 = {
  key: 4,
  class: "empl-review__middle-content"
}
const _hoisted_14 = { class: "empl-review__subtitle empl-review--center" }
const _hoisted_15 = { class: "comment__wrap" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "empl-review__note" }
const _hoisted_18 = {
  key: 5,
  class: "empl-review__middle-content"
}
const _hoisted_19 = { class: "empl-review__subtitle empl-review--center" }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = { class: "empl-review__bg-image" }
const _hoisted_22 = ["srcset"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empl-review__dummy-space" }, null, -1))
const _hoisted_25 = { class: "empl-review__title empl-review--center empl-review--mrg" }
const _hoisted_26 = { class: "empl-review__explanation" }

import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { computed, ref, watch } from "vue";
import { Button } from "mq-ui-kit/lib/Button";
import { TextArea } from "mq-ui-kit/lib/TextArea";
import ToastService from "mq-ui-kit/lib/toast";
import { FormControlModel } from "mq-ui-kit/lib/form-control-model";
import Avatar from "@/components/ui/Avatar.vue";
import RatingStars from "@/components/ui/RatingStars.vue";
import MutationTypes from "@/store/types/mutation-types";
import OverlayDialog from "@/components/ui/OverlayDialog.vue";
import {
  CompanyClientReviewLabelResponse,
  CompanyClientEmployeeReviewResponse,
  CompanyClientReviewLabelOfEmployee,
  //
  CompanyClientReviewLabelApplicationKindEnum,
} from "@/services/rest/dashboard";
import ActionTypes from "@/store/types/action-types";

interface DummyListInterface {
  labelId: number;
  positive: boolean;
  negative: boolean;
  description: string | unknown;
}

enum StepDirection {
  Next = "NEXT",
  Previous = "PREVIOUS",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeReviewModal',
  props: {
    member: null
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: "save"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  member: CompanyClientEmployeeReviewResponse,
};

const store = useStore();
const { t } = useI18n();





const step = ref(1);
const starRating = ref(0);
const dummyComments = ref<DummyListInterface[]>();
const positiveComments = ref<DummyListInterface[]>([]);
const negativeComments = ref<DummyListInterface[]>([]);
const isLiked = ref(false);
const note = ref(new FormControlModel({
  validations: [
    (value: string) => {
      let isValid = true;

      if(value.length > 0 && value.length < 3) {
        isValid = false;
      }

      return {
        isValid,
        validationType: "minRequired"
      }
    },
    (value: string) => {
      let isValid = true;

      if(step.value === 4 && (starRating.value === 1 || starRating.value === 2) && value.length === 0) {
        isValid = false;
      }

      return {
        isValid,
        validationType: "isMandatory"
      }
    },
  ],
  value: "",
  messages: {
    minRequired: t("validation.min_length_is", { number: 3 }),
    isMandatory: t("validation.pls_enter_note"),
  }
}));

const isLoading = ref(false);
const labelList = ref([]);
const isModalOpen = computed(() => store.state.isEmployeeReviewModalOpen);

const shiftDate = computed(() => new Date(props.member.shiftStartTimestamp).toLocaleDateString("en-GB"));

const resetFields = () => {
  step.value = 1;
  starRating.value = 0;
  note.value.setValue("");
  isLiked.value = false;
  positiveComments.value = [];
  negativeComments.value = [];
  dummyComments.value = [];
  labelList.value = [];
}

const closeDialog = () => {
  store.commit(MutationTypes.SET_IS_EMPLOYEE_REVIEW_MODAL_OPEN, false);
  resetFields();
}

const selectPositiveComment = (event: Event, item: DummyListInterface, index: number) => {
  if(positiveComments.value.some((el: DummyListInterface) => el.labelId === item.labelId)) {

    positiveComments.value = positiveComments.value.filter((el:DummyListInterface) => el.labelId !== item.labelId);
    dummyComments.value![index].positive = false;
    return;
  }

  dummyComments.value![index].positive = true;
  positiveComments.value.push(item);
}

const selectNegativeComment = (event: Event, item: DummyListInterface, index: number) => {
  if(negativeComments.value.some((el: DummyListInterface) => el.labelId === item.labelId)) {
    negativeComments.value = negativeComments.value.filter((el:DummyListInterface) => el.labelId !== item.labelId);
    dummyComments.value![index].negative = false;
    return;
  }

  dummyComments.value![index].negative = true;
  negativeComments.value.push(item);
};

const previous = () => {
  step.value--;
};

const next = () => {
  step.value++;
};

const formatLabelsForSave = () => [ ...positiveComments.value, ...negativeComments.value].map(el => ({
      labelId: el.labelId,
      labelAppKind: el.positive && !el.negative ?
        CompanyClientReviewLabelApplicationKindEnum.Positive :
        CompanyClientReviewLabelApplicationKindEnum.ImprovementPoint
    }));

const formatLabelsForStart = (userLabels: CompanyClientReviewLabelOfEmployee[]) => {
  userLabels.forEach((el: CompanyClientReviewLabelOfEmployee) => {
    if(el.labelAppKind === CompanyClientReviewLabelApplicationKindEnum.Positive) {
      positiveComments.value.push({
        labelId: el.labelId,
        positive: true,
        negative: false,
        description: ""
      });
    } else {
      negativeComments.value.push({
        labelId: el.labelId,
        positive: false,
        negative: true,
        description: ""
      });
    }
  });

  return labelList.value.map((el: CompanyClientReviewLabelOfEmployee) => {
    const user = userLabels.find((d: CompanyClientReviewLabelOfEmployee) => d.labelId === el.labelId);

    return {
      labelId: el.labelId,
      positive: !!(user && user.labelAppKind === CompanyClientReviewLabelApplicationKindEnum.Positive),
      negative: !!(user && user.labelAppKind === CompanyClientReviewLabelApplicationKindEnum.ImprovementPoint),
      description: el.description
    }
  });
};

const getLabels = () => store.dispatch(ActionTypes.GET_EMPLOYEE_REVIEW_LABELS)

const save = () => {
  if (!note.value.valid) return;

  const saveObject = {
    reviewId: props.member.reviewId ? props.member.reviewId : null,
    shiftId: props.member.reviewId ? null : props.member.shiftId,
    employeeId: props.member.employee.employeeId,
    labels: formatLabelsForSave(),
    reviewScore: starRating.value,
    note: (note.value.getValue() as string).length  === 0 ? null : note.value.getValue(),
    favourite: isLiked.value,
  };


  isLoading.value = true;

  store
    .dispatch(props.member.reviewId ?
      ActionTypes.UPDATE_EMPLOYEE_REVIEW : ActionTypes.CREATE_EMPLOYEE_REVIEW, saveObject)
    .then(() => {
      next();
    })
    .catch((e) => {
      console.log("Error", e);
      ToastService.errorToast(t("errors.something_went_wrong"));
    })
    .finally(()=>{
      isLoading.value = false;
    });
};

const likeMember = () => {
  isLiked.value = !isLiked.value;
};

const validateSteps = async (direction?: string) => {
  if (direction === StepDirection.Next) {
    if (step.value === 1 && !starRating.value) {
      ToastService.warningToast(t("validation.rate_not_provided"));
      return;
    }

    if (step.value === 1 && labelList.value.length === 0) {
      labelList.value = await getLabels();

      if (labelList.value.length !== 0) {
        dummyComments.value = props.member.reviewScore ?
        formatLabelsForStart(props.member.labels) :
        labelList.value
        .map((el: CompanyClientReviewLabelResponse) => ({...el, positive: false, negative: false}));
      } else {
        step.value = 3;
      }
    }

    if (step.value === 3 && (starRating.value === 1 || starRating.value === 2)) {
      note.value.markTouched();
    }

    if (step.value > 4) {
      return;
    }

    next();
  } else {

    if (labelList.value.length === 0) {
      step.value = 1;
    }

    if (step.value === 1) {
      return;
    }

    previous();
  }
};

const closeDialogAfterSave = () => {
  closeDialog();
  emit("save");
};

watch(()=> isModalOpen.value, (val)=> {
  if(val) {
    starRating.value = props.member.reviewScore;
    note.value.setValue(props.member.note ? props.member.note : "");
    isLiked.value = props.member.employee.favourite as boolean;
  }
});

const ratingControlMsg = computed(() => {
  return (step.value === 1 && (starRating.value === 1 || starRating.value === 2));
});


return (_ctx: any,_cache: any) => {
  const _component_FaIcon = _resolveComponent("FaIcon")!

  return (_openBlock(), _createBlock(OverlayDialog, {
    "modal-id": "empl-review-modal",
    "is-open": _unref(isModalOpen),
    onClose: closeDialog
  }, {
    header: _withCtx(() => []),
    content: _withCtx(() => [
      (step.value !== 5)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.$t('share_your_experience')), 1))
        : _createCommentVNode("", true),
      (step.value !== 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Avatar, {
              name: __props.member.employee.firstName,
              "last-name": __props.member.employee.lastName,
              "img-path": __props.member.employee.profilePictureUrl,
              "custom-size": 64,
              "custom-font-size": 24
            }, null, 8, ["name", "last-name", "img-path"]),
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(__props.member.employee.fullName), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.member.gigName) + " - " + _toDisplayString(_unref(shiftDate)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('how_satisfied_are_you_with_name', { name: __props.member.employee.firstName })) + "? ", 1),
            _createVNode(RatingStars, {
              modelValue: starRating.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((starRating).value = $event)),
              size: "large",
              "text-list": [
            _ctx.$t('global.terrible'),
            _ctx.$t('global.bad'),
            _ctx.$t('global.ok'),
            _ctx.$t('global.good'),
            _ctx.$t('global.great'),
          ]
            }, null, 8, ["modelValue", "text-list"]),
            (_unref(ratingControlMsg))
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('with_1_2_rating_need_note')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (step.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('positive_experience_working_with_name', { name: __props.member.employee.firstName })) + "? ", 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dummyComments.value, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: _normalizeClass(["comment__pill", [
              {'comment__pill--disabled ': item.negative},
              {'comment__pill--positive': item.positive},
              {'comment__pill--negative': item.negative},
            ]]),
                  key: item.labelId,
                  onClick: ($event: any) => (selectPositiveComment($event, item, index))
                }, [
                  _createTextVNode(_toDisplayString(item.description) + " ", 1),
                  _createVNode(_component_FaIcon, {
                    class: "",
                    icon: ['far', 'thumbs-up']
                  })
                ], 10, _hoisted_11))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('you_can_select_multiple_answers')), 1)
          ]))
        : _createCommentVNode("", true),
      (step.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('what_can_be_better', { name: __props.member.employee.firstName })) + "? ", 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dummyComments.value, (item, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: _normalizeClass(["comment__pill", [
              {'comment__pill--disabled': item.positive},
              {'comment__pill--positive': item.positive},
              {'comment__pill--negative': item.negative},
              {'comment__pill--rotate': step.value === 3}
            ]]),
                  key: item.labelId,
                  onClick: ($event: any) => (selectNegativeComment($event, item, index))
                }, [
                  _createTextVNode(_toDisplayString(item.description) + " ", 1),
                  _createVNode(_component_FaIcon, {
                    class: "",
                    icon: ['far', 'thumbs-up']
                  })
                ], 10, _hoisted_16))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('you_can_select_multiple_answers')), 1)
          ]))
        : _createCommentVNode("", true),
      (step.value === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('do_you_want_to_say_something_else')), 1),
            _createVNode(_unref(TextArea), {
              control: note.value,
              placeholder: _ctx.$t('make_short_note_about_employee'),
              class: "empl-review__hint"
            }, null, 8, ["control", "placeholder"]),
            _createElementVNode("button", {
              onClick: likeMember,
              class: "empl-review__like-btn"
            }, [
              (isLiked.value)
                ? (_openBlock(), _createBlock(_component_FaIcon, {
                    key: 0,
                    class: "empl-review__like-btn--red",
                    icon: "heart"
                  }))
                : (_openBlock(), _createBlock(_component_FaIcon, {
                    key: 1,
                    class: "empl-review__like-btn--grey",
                    icon: ['fal', 'heart']
                  })),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('add_as_favourite')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value === 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("picture", _hoisted_21, [
              _createElementVNode("source", {
                type: "image/webp",
                srcset: require('@/assets/img/employee-modal-hat.webp')
              }, null, 8, _hoisted_22),
              _createElementVNode("img", {
                src: require('@/assets/img/employee-modal-hat.png'),
                alt: _ctx.$t('your_experience_makes_difference')
              }, null, 8, _hoisted_23)
            ]),
            _hoisted_24,
            _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.$t('your_experience_makes_difference')) + "! ", 1),
            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('by_giving_start_you_helping_others', { name: __props.member.employee.firstName })) + "! ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      (step.value !== 1 && step.value <= 4)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            size: "medium",
            color: "outlined",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (validateSteps())),
            class: "empl-review__btn",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.previous')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (step.value <= 3)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 1,
            size: "medium",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (validateSteps(StepDirection.Next))),
            class: "empl-review__btn",
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.next')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (step.value === 4)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 2,
            size: "medium",
            onClick: save,
            class: "empl-review__btn",
            "show-loading": isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.save')), 1)
            ]),
            _: 1
          }, 8, ["show-loading"]))
        : _createCommentVNode("", true),
      (step.value === 5)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 3,
            size: "medium",
            onClick: closeDialogAfterSave,
            class: "empl-review__btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('done')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-open"]))
}
}

})